'use strict';
define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "dojo/i18n!nls/mldoStringResource"
], function (declare, Action, MLDOStrings) {
  return declare(Action, {
    constructor: function (args) {
        args = args || {};
        var context = args.context;
        var makeActionAvailable = args.showAction || false;
        this.name = MLDOStrings.contextMenuShareLabel;
        this.label = MLDOStrings.contextMenuShareLabel;
        this.enabled = makeActionAvailable;
        this.personalInvitationsEnabled = args.isPersonalInvitationsEnabled || false;
        this.id = "mldoShareAction";
        this.allowSubMenu = true;
        // TODO LEAVE
        // this.childActionIds = ["mldoManageAction", "mldoLinkAction", "mldoLeaveAction"];
        this.childActionIds = this.personalInvitationsEnabled === true ? ["mldoManageAction", "mldoLinkAction"] : ["mldoLinkAction"];
        this.section = {
            id: "MISC",
            name: "MISC",
            allowSubMenu: true,
            forceSubMenu: false
        };
        this.isApplicableTo = function (path) {
          var selectedFileCount = context.getSelectedRowCount();
          let fileInfo;
          if (selectedFileCount > 1) {
            this.enabled = false;
            return false;
          } else if (selectedFileCount === 0) {
            fileInfo = context.getCurrentFolderInfo();
          } else {
            fileInfo = context.getSelectedItemFileInfos()[0];
          }
          const isInShare = fileInfo.isSharedFolder || !!fileInfo.sharedParentPath;
          const isOwner = fileInfo.accessType === "OWNER";
          const canWrite = fileInfo.filePermissions && fileInfo.filePermissions.canWrite;

          // Disable for MLD root and for files that are not shareable
          if (fileInfo.name === "/" || (!fileInfo.isDirectory && !fileInfo.shareable)) {
            this.enabled = false;
            return false;
          }

          // Enable for owner of content that can be shared
          if (isOwner && canWrite) {
            this.enabled = makeActionAvailable && true;
          } else if (!isOwner && isInShare) {
            // Enable for non-owners in shared folders
            this.enabled = makeActionAvailable && true;
          } else {
            this.enabled = false;
          }
          return this.enabled;
        };
    }
  });

});
